/* istanbul ignore file */
import {Alignments} from '../types/galleryTypes';

export enum AlignItems {
  Center = 'center',
  FlexStart = 'flex-start',
  FlexEnd = 'flex-end',
}

export const getFlexAlignment = (alignment: Alignments, isRTL: boolean) => {
  switch (alignment) {
    case Alignments.LEFT:
      return isRTL ? AlignItems.FlexEnd : AlignItems.FlexStart;
    case Alignments.RIGHT:
      return isRTL ? AlignItems.FlexStart : AlignItems.FlexEnd;
    case Alignments.CENTER:
      return AlignItems.Center;
  }
};

export const getStartEndAlignment = (alignment: Alignments) => {
  switch (alignment) {
    case Alignments.LEFT:
      return Alignments.START;
    case Alignments.RIGHT:
      return Alignments.END;
    case Alignments.CENTER:
      return Alignments.CENTER;
  }
};

export const getLeftRightAlignment = (alignment: Alignments) => {
  switch (alignment) {
    case Alignments.START:
      return Alignments.LEFT;
    case Alignments.END:
      return Alignments.RIGHT;
    case Alignments.CENTER:
      return Alignments.CENTER;
  }
};
